/**
 * Ashore API
 * All Endpoints to control your ashore account
 *
 * The version of the OpenAPI document: V1
 * Contact: info@ashoreapp.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 *
 */

import ApiClient from '../ApiClient';
import Approver from './Approver';

/**
 * The ApproverWithStats model module.
 * @module model/ApproverWithStats
 * @version V1
 */
class ApproverWithStats {
    /**
     * Constructs a new <code>ApproverWithStats</code>.
     * @alias module:model/ApproverWithStats
     */
    constructor() { 
        
        ApproverWithStats.initialize(this);
    }

    /**
     * Initializes the fields of this object.
     * This method is used by the constructors of any subclasses, in order to implement multiple inheritance (mix-ins).
     * Only for internal use.
     */
    static initialize(obj) { 
    }

    /**
     * Constructs a <code>ApproverWithStats</code> from a plain JavaScript object, optionally creating a new instance.
     * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
     * @param {Object} data The plain JavaScript object bearing properties of interest.
     * @param {module:model/ApproverWithStats} obj Optional instance to populate.
     * @return {module:model/ApproverWithStats} The populated <code>ApproverWithStats</code> instance.
     */
    static constructFromObject(data, obj) {
        if (data) {
            obj = obj || new ApproverWithStats();

            if (data.hasOwnProperty('approver')) {
                obj['approver'] = Approver.constructFromObject(data['approver']);
            }
            if (data.hasOwnProperty('avgResponseRate')) {
                obj['avgResponseRate'] = ApiClient.convertToType(data['avgResponseRate'], 'Number');
            }
            if (data.hasOwnProperty('avgRoundsOfRevision')) {
                obj['avgRoundsOfRevision'] = ApiClient.convertToType(data['avgRoundsOfRevision'], 'Number');
            }
        }
        return obj;
    }

    /**
     * Validates the JSON data with respect to <code>ApproverWithStats</code>.
     * @param {Object} data The plain JavaScript object bearing properties of interest.
     * @return {boolean} to indicate whether the JSON data is valid with respect to <code>ApproverWithStats</code>.
     */
    static validateJSON(data) {
        // validate the optional field `approver`
        if (data['approver']) { // data not null
          Approver.validateJSON(data['approver']);
        }

        return true;
    }


}



/**
 * @member {module:model/Approver} approver
 */
ApproverWithStats.prototype['approver'] = undefined;

/**
 * @member {Number} avgResponseRate
 */
ApproverWithStats.prototype['avgResponseRate'] = undefined;

/**
 * @member {Number} avgRoundsOfRevision
 */
ApproverWithStats.prototype['avgRoundsOfRevision'] = undefined;






export default ApproverWithStats;

